import { useEffect, useRef, useState } from "react"

export default function useMeasures() {
    const ref = useRef(null)
    const [height, setHeight] = useState(0)

    function measure() {
        /** @type {HTMLDivElement} */
        const elem = ref.current

        if (!elem) {
            return
        }

        const rect = elem.getBoundingClientRect()
        setHeight(rect.height)
    }

    useEffect(() => {
        const observer = new ResizeObserver(measure)
        observer.observe(ref.current)

        return () => {
            observer.disconnect()
        }
    }, [])

    const measures = {
        height,
    }
    const bind = { ref }
    return [measures, bind]
}
